import { isDevMode } from './is-devmode';
const SIMULATE_ERROR_KEY = 'WHISPER_CORE_SIMULATE_ERROR';
const shouldSimulateLoadingError = scriptName => {
  try {
    return sessionStorage.getItem(SIMULATE_ERROR_KEY) === scriptName;
  } catch (e) {
    return false;
  }
};

/**
 * When dev mode is enabled checks storage for a specific key that indicates an
 * error should be thrown to simulate a loading failure. This is useful for
 * testing error handling in the application without needing to actually
 * fail to load a script.
 *
 * @param scriptName The name of the script to simulate loading error for
 */
export const simulateLoadingError = scriptName => {
  if (isDevMode() && shouldSimulateLoadingError(scriptName)) {
    const message = `Simulating ${scriptName} script loading error for development purposes. Delete entry "${SIMULATE_ERROR_KEY}" from session storage to disable this simulation.`;
    console.info(message);
    throw new Error(message);
  }
};